/**
 * Validates a US phone number with area code
 * Exactly 10 digits, can't start with 0 or 1
 */
export function phoneValidator(phone: string): boolean {
  return /^[2-9][0-9]{9}$/.test(phone);
}

/**
 * Sanitizes phone input to allow only valid US phone number digits.
 * Strips leading 1 (country code) and limits to 10 digits starting with 2-9.
 */
export function sanitizePhone(value: string): string {
  return value.replace(/^1/, '').replace(
    /^([2-9]?[0-9]{0,9})(.*)$/g,
    "$1"
  );
}
